<template>
  <f-container class="text-center my-5" v-if="loading || (!loading && counter)">
    <f-headline tag="h2" v-if="loading">Lädt ..</f-headline>
    <f-headline tag="h2" v-else>Wir haben <span class="text-primary">{{ counter }} Autos</span> im Abo für Dich gefunden</f-headline>
    <f-button variant="primary" class="my-3" :to="url">
      Fahrzeuge im Katalog anzeigen
    </f-button>
  </f-container>
</template>

<script>
    import {
      FButton,
      FContainer,
      FHeadline
    } from "faaren-ui";

    export default {
      name: "CatalogQueryCtaBox",
      components: {
        FContainer,
        FButton,
        FHeadline
      },
      props: {
        fuelId: {
          type: String,
          default: '-1'
        },
        brandId: {
          type: String,
          default: '-1'
        },
        modelId: {
          type: String,
          default: '-1'
        },
        categoryId: {
          type: String,
          default: '-1'
        },
        producerId: {
          type: String,
          default: '-1'
        }
      },
      data() {
        return {
          counter: 0,
          length: null,
          url: '',
          apiUrl: '',
          loading: true
        }
      },
      mounted() {
        this.buildUrl()
        this.getCounter()
      },
      methods:{
        buildUrl(){
          const string = `?&page=1&fuel=${this.fuelId}&brand=${this.brandId}&model=${this.modelId}&category=${this.categoryId}&producer=${this.producerId}`
          this.apiUrl = `/api/v1.0/vehicles${string}`
          this.url = `/katalog${string}`
        },
        getCounter(){
          axios.get(this.apiUrl)
              .then(result => {
                this.loading = false
                this.length = result.data.data.length
                this.counter = Math.round((this.length / 100)*50)

                this.animateValue()
              })
              .catch(error => {
                console.warn(error.message)
              });
        },
        animateValue() {
          if(this.counter < this.length){
            setTimeout(() => {
              this.counter++;
              this.animateValue()
            }, 250);
          }
        }
      }
    }
</script>

<style scoped>

</style>
